






import { Component, Vue } from 'vue-property-decorator';
import { Mutations, ViewModes, Views } from '@/ts/store/Constants';

@Component
export default class EventListButton extends Vue {
    constructor() {
        super();
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    public goToListView() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Events,
            viewMode: ViewModes.Events.EventListView,
        });
    }
}
